import {
  Box,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import { useNavigate, useParams } from "react-router-dom";
import { getBillsAction } from "../../../store/actions/bills/index";
import PieChartComponent from "../../../Components/PieChart";

const billStatuses = ["pending", "Paid", "Cancelled"];

export default function Bills() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, projectId, billId } = useParams();

  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });
  const [status, setStatus] = useState();

  const handleChangePage = (_, page) => {
    setPagination((prev) => ({ ...prev, page: page + 1 }));
  };

  const handleChangePerPage = (event) => {
    setPagination({ page: 1, perPage: +event.target.value });
  };

  const data = useSelector((s) => s?.bills?.data?.bill);
  const counts = useSelector((s) => s?.bills?.data?.counts);
  const totalBills = useSelector((s) => s?.bills?.data?.totalBills);
  const totalPrices = useSelector((s) => s?.bills?.data?.totalPrices);
  const loading = useSelector((s) => s?.bills?.loading);
  const count = useSelector((s) => s?.bills?.count);

  const getBills = useCallback(() => {
    getBillsAction({
      page: pagination?.page,
      limit: pagination?.perPage,
      creatorId: userId,
      projectId,
      status,
      billId,
    })(dispatch);
  }, [dispatch, userId, pagination, projectId, status, billId]);

  useEffect(() => {
    getBills && getBills({});
  }, [getBills]);

  return (
    <>
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", py: 3, width: 1 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            gap: "1em",
          }}
        >
          {!billId && (
            <>
              <Box sx={{ bgcolor: "#FAFAFA", p: "0.4em 1em" }}>
                <Typography variant="subtitle1" sx={{ color: "#081531" }}>
                  Bills
                </Typography>
              </Box>

              <Box
                sx={{ display: "flex", alignItems: "center", p: "0.4em 1em" }}
              >
                <Typography fontWeight="bold" sx={{ mr: 1 }}>
                  Total Bills:
                </Typography>
                <Typography>{totalBills}</Typography>
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", p: "0.4em 1em" }}
              >
                <Typography fontWeight="bold" sx={{ mr: 1 }}>
                  Total Prices:
                </Typography>
                <Typography>{totalPrices}</Typography>
              </Box>

              {counts?.length > 0 && (
                <PieChartComponent title={"Bill Status"} data={counts} />
              )}

              <Select
                placeholder={"Choose offer status"}
                inputProps={{ name: "type" }}
                value={status}
                renderValue={
                  status
                    ? undefined
                    : () => (
                        <Typography variant="subtitle1" color="text.disabled">
                          Choose bill status
                        </Typography>
                      )
                }
                displayEmpty
                onChange={(e) => setStatus(e?.target?.value)}
                MenuProps={{
                  PaperProps: {
                    sx: { maxHeight: "300px" },
                  },
                }}
                sx={{ mt: 1, width: 1 }}
              >
                {billStatuses?.map((e, i) => (
                  <MenuItem key={i} value={e}>
                    {e}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}

          <Box sx={{ bgcolor: "#FFF", p: "1em" }}>
            <DataTable
              data={data?.map((bill) => {
                const formattedBill = {
                  ...bill,
                  project: bill?.project?.name,
                  owner: bill?.project?.creator?.username,
                  offer: bill?.offer?.price,
                  supplier: bill?.offer?.user?.username,
                };
                delete formattedBill.creatorId;
                delete formattedBill.offerId;
                delete formattedBill.projectId;
                return formattedBill;
              })}
              handleChangePage={handleChangePage}
              handleChangePerPage={handleChangePerPage}
              perPage={pagination?.perPage}
              count={count}
              page={pagination?.page}
              onClick={(row) => navigate(`/bill/${row?.id}`)}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
